import { getAll, getCatalog } from '../api/catalogs';

export const fetchCatalog = (catalogId) => getCatalog(catalogId);
export const fetchCatalogs = () => getAll();
